import axios from 'axios'
import settings from '@/settings.js'

export const Http = axios.create({
  baseURL: settings.API_BASE_URL
})

let authHttpMode

if (process.env.NODE_ENV === 'development') {
  authHttpMode = 'http'
} else {
  authHttpMode = 'https'
}

export const authURL = `${authHttpMode}://${settings.AUTH_DOMAIN}`

export const AuthHttp = axios.create({
  baseURL: authURL
})

export const setHeader = (header, value) => {
  Http.defaults.headers.common[header] = value
  AuthHttp.defaults.headers.common[header] = value
}
